<section class="w-full">
@if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.contact) {
        @case (1) {
            <app-contact-type01></app-contact-type01>
            }
        @case (2) {
            <app-contact-type02></app-contact-type02>
            }
        @case (3) {
            <app-contact-type03></app-contact-type03>
            }
    }
}
</section>